module.exports = __webpack_public_path__ + "static/media/lira-sign.aa364877.svg";